import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Check for store version and clear old data if needed
// This must run BEFORE React mounts to prevent race conditions with initial state loading
// Specifically handling the migration from localhost IDs (small integers) to Live IDs (700+)
// try {
//   const STORE_VERSION = '2.0'; // Increment this when DB schema changes significantly
//   const currentVersion = localStorage.getItem('venzowood_store_version');
//
//   if (currentVersion !== STORE_VERSION) {
//     // console.log('Wait! Cleaning up old storage data for new version...');
//     localStorage.removeItem('cart');
//     localStorage.removeItem('quotation');
//     // We keep the token so the user stays logged in
//     localStorage.setItem('venzowood_store_version', STORE_VERSION);
//     // console.log('Cleanup complete. Storage updated to version', STORE_VERSION);
//   }
// } catch (e) {
//   console.error('Storage cleanup failed', e);
// }

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
